/*
 * Custom JavaScript
 * ===========================================================================
 *
 * Use this file to add your own custom JavaScript code.
 *
 * This file is loaded at the end of the body with the 'defer' attribute,
 * which means it will execute after the HTML document has been parsed.
 *
 * Tips:
 * - The DOM is ready when this script runs (no need for DOMContentLoaded)
 * - You can use Shopify's global objects like:
 *   - window.Shopify - Shopify global object with shop info
 *   - window.routes - Cart and search URLs
 *   - window.cartStrings - Cart-related translation strings
 *   - window.variantStrings - Product variant translation strings
 *
 * - The theme uses a pub/sub pattern for events. You can subscribe to events:
 *   - subscribe(PUB_SUB_EVENTS.cartUpdate, callback) - Cart updates
 *   - subscribe(PUB_SUB_EVENTS.quantityUpdate, callback) - Quantity changes
 *
 * - Common DOM queries:
 *   - document.querySelector('.selector') - Get single element
 *   - document.querySelectorAll('.selector') - Get all matching elements
 *
 * ===========================================================================
 */

/* Add your custom JavaScript below this line */

/* DELVANIE : prix sans ,00 (04/10/2026) */
(function () {
  // Les rares prix ecrits par JavaScript (barre d'achat collante au changement de variante) passent par
  // Shopify.formatMoney. Ce theme ne la definit pas : le repli du composant affichait "$195.00".
  // On la definit donc ici, au format de la boutique, sans decimales nulles (159€, 318,60€, 1.235,80€).
  function euros(cents) {
    var n = (Number(cents) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return whole + (parts[1] === '00' ? '' : ',' + parts[1]) + '\u202f€';
  }
  function patch() {
    window.Shopify = window.Shopify || {};
    if (typeof Shopify.formatMoney === 'function') {
      if (Shopify.formatMoney.__dlvNoZeros) return;
      var original = Shopify.formatMoney;
      var wrapped = function () {
        var out = original.apply(this, arguments);
        return typeof out === 'string' ? out.replace(/[.,]00(?!\d)/, '').replace(/\s?€/, '\u202f€') : out;
      };
      wrapped.__dlvNoZeros = true;
      Shopify.formatMoney = wrapped;
      return;
    }
    var own = function (cents) { return euros(cents); };
    own.__dlvNoZeros = true;
    Shopify.formatMoney = own;
  }
  patch();
  document.addEventListener('DOMContentLoaded', patch);
  window.addEventListener('load', patch);
})();
